// Texto livre dos eventos (justificativa do cancelamento/inutilização, texto da
// CC-e). Espelho de sanitizar_texto_evento em backend/app/services/sefaz_client.py
// — manter os dois sincronizados. A tela conta os caracteres do texto JÁ
// TRATADO, que é o que vai no XML (ex.: "…" vira "..." e conta 3).

export const MINIMO_TEXTO_EVENTO = 15;
export const LIMITE_JUSTIFICATIVA = 255;
export const LIMITE_CORRECAO = 1000;

// Pontuação tipográfica colada de e-mail/WhatsApp/Word → equivalente aceito.
const TRANSLITERACAO = {
  '–': '-',    // – travessão
  '—': '-',    // — travessão longo
  '‘': "'",    // ‘
  '’': "'",    // ’
  '“': '"',    // “
  '”': '"',    // ”
  '…': '...',  // …
  ' ': ' ',    // espaço inquebrável
  '•': '-',    // • marcador
};

export function tratarTextoEvento(texto) {
  let t = String(texto ?? '').replace(/\s+/g, ' ');
  t = t.replace(/[–—‘’“”… •]/g, c => TRANSLITERACAO[c]);
  t = t.replace(/[^ -ÿ]/gu, '');  // emoji e o que mais estiver fora da faixa
  return t.replace(/\s+/g, ' ').trim();
}

export function situacaoTextoEvento(texto, limite) {
  const n = tratarTextoEvento(texto).length;
  return { n, curto: n < MINIMO_TEXTO_EVENTO, excedeu: n > limite,
           ok: n >= MINIMO_TEXTO_EVENTO && n <= limite };
}
